// covered-by: frontends/carrie/src/routes/ask-puntt/components/__tests__/ImageCommentPin.test.tsx
import { type BaseTicketComment } from "@mg/schemas/src/christo/catalyst";
import { createContext } from "react";

/**
 * Names a pin whose finding was rejected in this review, for a reader.
 *
 * Set only by the Ask v2 artwork viewer, which draws a rejected finding's pin
 * grayed in its place. With no provider (every v1 surface) a pin renders
 * exactly as it always has, whatever `liked` says.
 *
 * why a context and not a prop: the pins render inside the image and PDF
 * viewers nested in `AssetViewerPane`, a 5k-line v1 monolith; a prop would
 * thread through each of them for a v2-only look.
 */
export const RejectedPinLabelContext = createContext<
  ((comment: BaseTicketComment) => string) | null
>(null);
